function rangeWidth(rangeEndQuantity, rangeBegin) {
  const rangeEnd = rangeEndQuantity || Infinity;
  return rangeEnd - rangeBegin + (rangeBegin === 0 ? 0 : 1);
}

function tierQuotationQuantity(quantity, range) {
  const width = rangeWidth(range.end_quantity, range.start_quantity);
  return quantity > width ? width : quantity;
}

function calculate(pricingRange, quantity) {
  return quantity * parseFloat(pricingRange.price);
}

function tierUsage(pricingRange, quantity, price) {
  let quantityLeft = quantity;
  let amount = 0;

  pricingRange.every((range) => {
    if (quantityLeft <= 0) return false;
    amount += calculate(range,
      tierQuotationQuantity(quantityLeft, range));
    quantityLeft -= rangeWidth(range.end_quantity, range.start_quantity);
    return true;
  });

  return parseFloat(price) + amount;
}

export default tierUsage;
